import React from 'react';

const FormApproval = ({ formData, handleApprovalChange }) => {
  return (
    <div className="bg-[var(--bg-primary)] p-6 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-4">
        Persetujuan
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Metode Persetujuan
          </label>
          <select
            name="method"
            value={formData.approval?.method || 'whatsapp'}
            onChange={handleApprovalChange}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="whatsapp">WhatsApp</option>
            <option value="telepon">Telepon</option>
            <option value="email">Email</option>
            <option value="langsung">Langsung</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Status Persetujuan
          </label>
          <select
            name="status"
            value={formData.approval?.status || 'pending'}
            onChange={handleApprovalChange}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="pending">Pending</option>
            <option value="approved">Disetujui</option>
            <option value="rejected">Ditolak</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
            Tanggal Persetujuan
          </label>
          <input
            type="date"
            name="date"
            value={formData.approval?.date ? formData.approval.date.split('T')[0] : ''}
            onChange={handleApprovalChange}
            className="w-full px-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
    </div>
  );
};

export default FormApproval;